export default {
  home: 'หน้าแรก',
  login: 'เข้าสู่ระบบ',
  management: 'ระบบบริหารหอพัก',
  about: 'เกี่ยวกับเรา',
  findFromCurrentLocation: 'ค้นหาจากตำแหน่งปัจจุบัน',
  register: {
    title: 'ลงทะเบียนหอพักในระบบ',
    apartment: {
      chooseTitle: 'เลือกหอพัก',
      title: 'ชื่อหอพัก',
      addressTitle: 'ที่อยู่',
      furnitureTitle: 'เฟอร์นิเจอร์',
      geo: 'พิกัดของหอพัก',
      titleOnline: 'ชื่อหอพักที่แสดงบนเว็บหาหอ',
      addressOnline: 'ที่อยู่หอพักที่แสดงบนเว็บหาหอ',
      bedSize: 'ขนาดเตียง'
    },
    roomTypeTitle: 'ประเภทห้อง',
    addRoomType: 'ประเภทห้อง',
    selectRooms: 'เลือกห้อง',
    roomTypeNamePH: 'กรอกชื่อประเภทห้อง',
    agreementTitle: 'ข้อตกลงการใช้งาน',
    agreement: '-- ข้อตกลงการใช้งาน --',
    agreementConfirm: 'ฉันได้อ่านข้อตกลงและยอมรับการใช้งาน',
    regist: 'บันทึก',
    enterRoomCount: 'กรอกจำนวนห้องที่มี',
    enterMinRoomCost: 'กรอกราคาห้องขั้นต่ำ',
    enterMaxRoomCost: 'กรอกราคาห้องมากที่สุด',
    enterMaxRenter: 'กรอกจำนวนผู้เข้าพักมากที่สุด',
    enterBedCount: 'กรอกจำนวนเตียง'
  },
  selectFurniture: 'เลือกของใช้ภายในห้อง',
  tv: 'โทรทัศน์',
  refrigerator: 'ตู้เย็น',
  air: 'เครื่องปรับอากาศ',
  bed: 'เตียง',
  cabinet: 'ตู้เสื้อผ้า',
  workingTable: 'โต้ะทำงาน',
  dressingTable: 'โต้ะเครื่องแป้ง',
  waterHeater: 'เครื่องทำน้ำอุ่น',
  clothLine: 'ราวตากผ้า',
  microwave: 'ไมโครเวฟ',
  internet: 'อินเตอร์เน็ต',
  selectFacility: 'เลือกสิ่งอำนวยความสะดวกส่วนกลาง',
  selectRule: 'นโยบายของหอพัก',
  elevator: 'ลิฟท์',
  washer: 'เครื่องซักผ้า',
  fitness: 'ฟิตเนส',
  waterFilter: 'เครื่องกรองน้ำ',
  cctv: 'กล้องวงจรปิด',
  parking: 'ที่จอดรถยนต์',
  shoeRack: 'ชั้นวางรองเท้า',
  motorBikeParking: 'ที่จอดรถมอเตอร์ไซค์',
  index: {
    welcome: "ยินดีต้อนรับ",
    header_title1: "กำลังมองหาหอพัก ?",
    header_title2: "ให้ Horganice ช่วยหาหอพักที่ถูกที่ใช่สำหรับคุณ ฟรี !",
  },
  navbar: {
    login_btn: "ลงชื่อเข้าใช้",
    inputSearch: "ละแวกที่คุณต้องการพัก",
  },
  termOfService: `
ข้อกำหนดและเงื่อนไขการใช้บริการ (Term of Service)

rentini.in.th ในการดูแลของ บริษัท ฮอร์แกไนซ์ จำกัด (“บริษัท”) ขอขอบคุณท่านผู้ใช้บริการทุกท่านที่เข้าเยี่ยมชมเว็บไซด์ของเรา เพื่อทำความเข้าใจและตกลงยอมรับเกี่ยวกับการใช้บริการของเรา จึงขอเรียนว่าบริษัทมีข้อกำหนดและเงื่อนไขการใช้งานดังนี้

คำนิยาม (Definitions)
“บริษัท” หมายถึง บริษัท ฮอร์แกไนซ์ จำกัด
“เว็ปไซด์” หมายถึง www.rentini.in.th

การใช้งานเว็บไซด์ (Description Of Service)
rentini.in.th ให้บริการเป็นสื่อกลางข้อมูลด้านธุรกิจอสังหาริมทรัพย์ปล่อยเช่า เพื่อให้ผู้ใช้บริการสามารถค้นหาที่พักได้ เพื่อความปลอดภัยและเป็นระเบียบในการใช้บริการ ท่านตกลงว่า ท่านจะไม่กระทำการใด ที่จะเป็นการล่วงละเมิดสิทธิส่วนบุคคล และ/หรือสิทธิในทรัพย์สินทางปัญญา ทั้งบุคคลภายนอกและ/หรือ ของบริษัท , ไม่ส่งเนื้อหา รวมถึงการนำข้อความ รูปภาพ หรือ ภาพเคลื่อนไหว ที่ไม่เหมาะสม ไม่สุภาพ มีลักษณะเสียดสี ก่อให้เกิดความขัดแย้ง เป็นความลับ หรือเป็นเท็จ รวมทั้งข้อความและรูปภาพที่มีลักษณะขัดต่อกฎหมาย หรือศีลธรรม เผยแพร่ผ่านบริการของเว็บไซด์ หรือกระทำการอื่นใดอันอาจก่อให้เกิดความสูญเสีย หรือเสียหายต่อบริษัท และ/หรือบุคคลภายนอก หากปรากฎว่ามีการละเมิด บริษัท ขอสงวนสิทธิ ในการลบ ระงับ ข้อความ รูปภาพ ใด ๆ โดยไม่ต้องบอกกล่าวล่วงหน้า และบริษัท ไม่ต้องรับผิดชอบในความเสียหายใด ๆ ทั้งสิ้น

การจำกัดความรับผิด (Disclaimer policy)
บริษัทขอเรียนว่า บริษัทเป็นสื่อกลางข้อมูล ไม่ใช่ตัวแทนหรือหุ้นส่วนกับเจ้าของข้อมูลในแต่ละอพาร์เมนท์ การนำเสนอข้อมูลดังกล่าวหาก ก่อให้เกิดความเสียหาย แก่ผู้ใช้บริการ จึงไม่ก่อให้เกิดสิทธิ , ความรับผิด และ/หรือ ภาระผู้พันทางกฏหมายไม่ว่ากรณีใดๆทั้งสิ้น แต่หากข้อมูลมีความผิดพลาด ทางเรายินดีให้เจ้าของข้อมูล/บริษัท แก้ไขให้ถูกต้อง

ลิขสิทธิ์ตามกฎหมาย (Copyrights)
บริษัทขอแจ้งให้ทราบว่า เครื่องหมายการค้า ชื่อทางการค้า ข้อมูล เนื้อหา รูปภาพ หรือส่วนต่างๆที่ปรากฏในเวปไซด์ทั้งหมด ได้รับความคุ้มครอง ตามกฏหมายทรัพท์สินทางปัญญา ของบริษัท ห้ามมิให้ คัดลอก ดัดแปลง ปลอมแปลง ทำซ้ำ หรือใช้ซอฟต์แวร์ใดๆ ในการนำข้อมูลและบริการส่วนหนึ่งส่วนใด เพื่อแสวงหาประโยชน์ ทางการค้า หรือประโยชน์ทางมิชอบ โดยไม่ได้รับอนุญาตจากบริษัท บริษัทจะดำเนินการตามกฎหมายกับผู้ละเมิดสิทธิดังกล่าวโดยทันที
การเปลี่ยนแปลงการให้บริการ (Modifications to Service)
บริษัทขอสงวนสิทธิ์ที่จะเปลี่ยนแปลง แก้ไข หยุดการให้บริการเว็ปไซด์ รวมถึงการพักบริการเพื่อการปรับเปลี่ยนด้านซอร์ฟแวร์ หรือเหตุขัดข้องทางเทคนิค เหตุผลใดๆก็ตาม โดยมิต้องแจ้งผู้ใช้บริการให้ทราบล่วงหน้า ทั้งนี้ ข้อกำหนดและเงื่อนไขการใช้บริการรวมถึง หลักเกณฑ์การลงโฆษณา อาจมีการเปลี่ยนแปลข้อความ ตามที่บริษัทเห็นสมควร
 `
}
